import { useMemo } from "react";
import { queries } from "../../shared/queries";
import { type ResolveScopeName, buildResolveScopeName } from "../lib/roleChip";
import { useQuery } from "@rocicorp/zero/react";

export function useResolveScopeName() {
  const [spaces] = useQuery(queries.spacesLite({ includeAdminSpaces: true }));
  const [apps] = useQuery(queries.connectedAppsLite());
  const [groups] = useQuery(queries.allUserGroups());
  const [skills] = useQuery(queries.skillsLite());
  const [networks] = useQuery(queries.networks());
  const [serviceAccounts] = useQuery(queries.serviceAccounts());
  const resolveScopeName: ResolveScopeName = useMemo(
    () =>
      buildResolveScopeName(
        spaces,
        apps,
        groups,
        skills,
        networks,
        serviceAccounts
      ),
    [spaces, apps, groups, skills, networks, serviceAccounts]
  );
  const personalSpaceIds = useMemo(
    () => new Set(spaces.filter((s) => s.mode === "personal").map((s) => s.id)),
    [spaces]
  );
  return { resolveScopeName, personalSpaceIds };
}
